import { isPlatformBrowser, NgIf } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output, PLATFORM_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { FuseAlertComponent } from '@fuse/components/alert';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-create-password',
  standalone: true,
  imports: [NgIf, NgxSkeletonLoaderModule, FuseAlertComponent, ReactiveFormsModule, MatIconModule, FormsModule, MatInputModule],
  templateUrl: './create-password.component.html',
  styleUrl: './create-password.component.scss'
})
export class CreatePasswordComponent {

  @Input() userName: string;
  @Output() passwordValue = new EventEmitter();

  public loading: boolean = true;
  public showAlert: boolean = false;

  public passwordIsValid: boolean;

  public password: string;

  private referrer: string;

  constructor(
    private _router : Router,
    private _gtmService: GtmService,
    
     @Inject(PLATFORM_ID) private platformId: any
  ) { }

  // ngOnInit() {
  //   if (isPlatformBrowser(this.platformId)) {

  //     if(localStorage.getItem('currentURL')) {
  //       if(localStorage.getItem('currentURL') == window.location.href) {
  //       } else {
  //         this.referrer = localStorage.getItem('currentURL')
  //         localStorage.setItem('currentURL', window.location.href);
  //         localStorage.setItem('previousURL', this.referrer);
  //       }
  //     } else {
  //       localStorage.setItem('currentURL', window.location.href);
  //     }
  
  //     const route = window.location.href;
  //     const path = this._router.url;
  //     this._gtmService.pushEvent({ 
  //       event: 'sign_in_dealer',
  //       page_url: route,
  //       page_path: path,
  //       page_referrer: this.referrer ? this.referrer : route,
  //       page_title: 'pre-orders',
  //     });
  //   }
 
  // }


  ngOnChanges() {
    if (this.userName) {
      this.loading = false;
    }
  }

  public onPasswordChange(val: any)  {

    const regExp = RegExp(('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}'));

    if(val.target.value.length >= 8) {

      this.password = val.target.value;

      if(regExp.test(this.password)) {
        this.passwordIsValid = true;
        this.passwordValue.emit({password: this.password, passwordIsValid: this.passwordIsValid});
      } else {
        this.passwordIsValid = false;
      }
    }

  }

}
